import api, { pageData } from "./client";

export const ventasApi = {
  create: (data) => api.post("/ventas/", data),
  getAll: async (params = {}) => pageData((await api.get("/ventas/", { params })).data),
  getById: (id) => api.get(`/ventas/${id}/`),
  cancel: (id) => api.patch(`/ventas/${id}/anular/`),
  dashboard: () => api.get("/ventas/dashboard/"),
};



